export function PhoneFrame({ src, alt, variant = 'android', className = '' }) {
  const ios = variant === 'ios';
  return (
    <div className={`relative rounded-[2.75rem] bg-gradient-to-b from-[#2a2d36] to-[#0d0e12] p-[7px] shadow-[0_40px_80px_-20px_rgba(0,0,0,0.9),0_0_0_1px_rgba(255,255,255,0.08)] ${className}`}
         data-testid={`phone-frame-${variant}`}>
      <div className="relative overflow-hidden rounded-[2.35rem] bg-black ring-1 ring-black">
        <img src={src} alt={alt} loading="lazy" className="block aspect-[390/844] w-full object-cover object-top" draggable={false} />
        {ios ? (
          <span className="absolute left-1/2 top-2.5 h-[22px] w-[34%] -translate-x-1/2 rounded-full bg-black" />
        ) : (
          <span className="absolute left-1/2 top-3 h-3 w-3 -translate-x-1/2 rounded-full bg-black ring-1 ring-white/10" />
        )}
        <span className="pointer-events-none absolute inset-0 rounded-[2.35rem] bg-gradient-to-br from-white/10 via-transparent to-transparent" />
      </div>
      <span className={`absolute top-28 h-14 w-[3px] rounded-r bg-[#2a2d36] ${ios ? '-left-[3px]' : '-right-[3px]'}`} />
    </div>
  );
}

export function BrowserFrame({ src, alt }) {
  return (
    <div className="overflow-hidden rounded-2xl border border-white/10 bg-surface-card shadow-[0_50px_100px_-30px_rgba(255,165,0,0.25)]" data-testid="browser-frame">
      <div className="flex items-center gap-1.5 border-b border-white/5 bg-[#0E1017] px-4 py-2.5">
        <span className="h-2.5 w-2.5 rounded-full bg-[#FF5F57]" /><span className="h-2.5 w-2.5 rounded-full bg-[#FEBC2E]" /><span className="h-2.5 w-2.5 rounded-full bg-[#28C840]" />
        <span className="ml-3 truncate rounded-md bg-white/5 px-3 py-0.5 font-mono text-[10px] text-muted-foreground">mymusicia.com/create</span>
      </div>
      <img src={src} alt={alt} className="block w-full" loading="eager" draggable={false} />
    </div>
  );
}

export function Waves({ bars = 48, className = '' }) {
  return (
    <div className={`flex h-full items-end justify-center gap-[3px] ${className}`} aria-hidden="true">
      {Array.from({ length: bars }).map((_, i) => (
        <span key={i} className="wave-bar w-[3px] rounded-full bg-gradient-to-t from-brand/10 via-brand/60 to-brand"
              style={{ animationDelay: `${(i * 97) % 1400}ms`, height: `${30 + ((i * 37) % 70)}%` }} />
      ))}
    </div>
  );
}
